import React from 'react';
import { CheckCircle2, Target, Settings, Users, Sparkles, Camera } from 'lucide-react';
import { companyInfo, aboutFeatures } from '../mockData';

const iconComponents = {
  CheckCircle2,
  Target,
  Settings,
  Users
};

const About = () => {
  return (
    <section id="about" className="bg-gradient-to-b from-white via-gray-50/30 to-white relative overflow-hidden py-12 md:py-20">
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header - Mobile optimiert */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#DC2626]/10 px-4 py-1.5 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-[#DC2626]" />
            <span className="text-sm font-semibold text-[#DC2626]">Über uns</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight px-2">
            Ihr vertrauensvoller Partner für
            <span className="block mt-2 bg-gradient-to-r from-[#DC2626] to-[#B91C1C] bg-clip-text text-transparent">
              Altbausanierung
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            Seit {companyInfo.founded} setzen wir mit unserem {companyInfo.teamSize}-köpfigen Team auf Qualität, Präzision und traditionelles Handwerk.
          </p>
        </div>

        {/* Main Content Grid - Mobile optimiert */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start max-w-6xl mx-auto">
          {/* Left: Team Image Placeholder */}
          <div className="relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-gray-100 to-gray-200 h-64 sm:h-80 md:h-96 lg:h-[480px] flex items-center justify-center">
              <div className="text-center px-6">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-white/80 flex items-center justify-center">
                  <Camera className="w-10 h-10 text-gray-400" />
                </div>
                <p className="text-lg font-semibold text-gray-500">Team Foto</p>
                <p className="text-sm text-gray-400 mt-1">Kommt in Kürze</p>
              </div>
            </div>
            {/* Experience Badge - nur auf größeren Bildschirmen */}
            <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#DC2626] text-white p-6 rounded-2xl shadow-xl">
              <div className="text-4xl font-bold">{companyInfo.experience}+</div>
              <div className="text-sm">Jahre Erfahrung</div>
            </div>
          </div>

          {/* Right: Text mit Features - Mobile optimiert */}
          <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
            {/* Mobile Experience Badge */}
            <div className="flex md:hidden items-center gap-4 p-4 bg-[#DC2626] text-white rounded-xl mb-4">
              <div className="text-3xl font-bold">{companyInfo.experience}+</div>
              <div className="text-sm">Jahre Erfahrung in der Altbausanierung</div>
            </div>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              Mit über <span className="font-bold text-[#DC2626]">{companyInfo.experience} Jahren Erfahrung</span> im Bereich der Altbausanierung sind wir Ihr kompetenter Partner für anspruchsvolle Renovierungsprojekte.
            </p>
            
            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              Unser Fokus liegt auf der fachgerechten Restaurierung historischer Gebäude unter Berücksichtigung modernster Technologien und traditioneller Handwerkskunst.
            </p>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              Von der ersten Beratung bis zur finalen Übergabe begleiten wir Sie persönlich und sorgen für eine reibungslose Projektabwicklung.
            </p>

            {/* Features - Mobile optimiert als 2x2 Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 pt-2 md:pt-4">
              {aboutFeatures.map((feature, index) => {
                const IconComponent = iconComponents[feature.icon];
                return (
                  <div
                    key={index}
                    className="group flex items-start space-x-3 p-3 sm:p-4 rounded-xl bg-white border border-gray-100 hover:border-[#DC2626]/30 transition-all duration-300 shadow-sm hover:shadow-md"
                  >
                    <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-[#DC2626] to-[#B91C1C] flex items-center justify-center shadow-md flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                      <IconComponent className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-0.5 sm:mb-1">{feature.title}</h3>
                      <p className="text-gray-600 text-xs leading-relaxed line-clamp-2">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
